import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function MithranDoraisamy() {
  const mithranDoraisamySchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Mithran Doraisamy",
    "jobTitle": "Strategic Consultant",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/mithran-doraisamy"
  };

  return (
    <div className="corporateAdvisorsBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Mithran Doraisamy - Strategic Consultant"
        description="Mithran is a non-executive director and an executive coach, mentor and advisor with extensive experience in business growth and transformation."
        keywords={['Mithran Doraisamy', 'Strategic Consultant', 'Business Growth', 'Executive Coaching', 'Transformation']}
        ogImage="/mithranDoraisamy.webp"
        schema={mithranDoraisamySchema}
      />

      <div className="page-width px-20 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[3.8rem]" aria-label="Breadcrumb">
          <Link to="/leadership/corporate-advisors" className="text-white hover:text-primary-red transition-colors">
            Corporate Advisors
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Mithran Doraisamy</span>
          </div>
        </nav>

        <div className="flex flex-col gap-4 md:gap-16 pt-24">
          <div className="text-[3.8rem] md:text-[4.8rem] font-bold leading-[4.2rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Mithran Doraisamy
          </div>
          <div className="text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Strategic Consultant
          </div>
        </div>
      </div>

      <div className="pt-[130px] xl:pt-[90px] xl:pb-[80px] page-width">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/mithranDoraisamy.webp" 
                alt="Mithran Doraisamy, Strategic Consultant - Expert in Business Growth and Transformation" 
                className="w-full" 
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="text-[2rem] leading-[3.6rem] tracking-[0.8px] font-normal text-left text-white">
                Mithran is a non-executive director and an executive coach, mentor and advisor. 
He has had senior roles in large organisations across an executive and consulting career focused on driving business growth and transformation across multiple industries. He has been a Senior Partner at Korn Ferry, a Senior Partner at Partners in Performance (now part of Accenture), a senior executive at Telstra driving productivity and strategy, and a Managing Partner of Customer and Transformation at EY, a practice that he also co-founded. He recently retired from full-time executive life. 
Mithran has a Bachelor of Science (Computer Science and Accounting) from Monash University, an MBA from the Melbourne Business School and numerous professional certificates across a range of disciplines e.g. cybersecurity, energy transition, digital transformation and innovation. He is a Fellow of Chartered Accountants ANZ (FCA) and a Fellow of the Australian Institute of Company Directors (FAICD).
              </div>
              

            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="mithran-doraisamy" 
        basePath="/leadership" 
      />
    </div>
  );
}